import {
    ADMINDELETELANGUAGEMAPPING_SUCCESS,
    ADMINDELETELANGUAGEMAPPING_FAILED,
    RESET_ADMINDELETELANGUAGEMAPPING,
    LOADING_ADMINDELETELANGUAGEMAPPING,
    NETWORK_ERROR_ADMINDELETELANGUAGEMAPPING
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADMINDELETELANGUAGEMAPPING:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case ADMINDELETELANGUAGEMAPPING_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case ADMINDELETELANGUAGEMAPPING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_ADMINDELETELANGUAGEMAPPING:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_ADMINDELETELANGUAGEMAPPING:
            return (state = initialState);
        default:
            return state;
    }
};
